import 'isomorphic-fetch'
import 'svgxuse'

import { moveMenu } from './sticky_product_menu'
import {
  initProductSlider,
  initRelProductSlider,
  initRelProductSliderSm,
  initRelReferencesSlider,
  initHomeReferencesSlider,
  initLatestArticlesSlider,
  initSingleReferenceSlider,
  initAboutArticlesSlider,
} from './sliders'
import { handleSpecsTabs, handleSpecsTabs2 } from './tabs'
import Tabs from './stdTabs'
import { show3DViewButton } from './buttons'
import { handleLabels, handlePasswordLabels, hideOnConfirmation } from './forms'
import { filterPeople, filterReferences } from './filters'
// import init from './react/products'
import {
  scrollToEventHandler,
  scrollButton,
  scrollToFinishSection,
  applyShadowToNav,
} from './smoothscroll'
import handleClickOnCTA from './services'
import {
  openServiceModal,
  openCampaignModal,
  openMenu,
  openStickyCTA,
  openApplyModal,
  openChangePasswordModal,
} from './modal'
import { initStoresMap, initProjectsMap } from './maps'
import { slideInOutSearch, setNoResultsHeight, debounce } from './utilities'
import { moveJobMenu } from './sticky_job_menu'
import heroDot from './dots'

import addGalleryModal from './gallery'
import initCampaignBanner from './campaign-banner'
import initCookieConsent from './cookie-consent'

import {
  sortProducts,
  triggerFacetChildren,
  setDivHeights,
  facetLoader,
} from './facets'

const ES6Promise = require('es6-promise')
const throttle = require('lodash.throttle')

ES6Promise.polyfill()

const isFacetsTemplate = document.body.classList.contains(
  'page-template-template-products-facets',
)

addGalleryModal()

initCampaignBanner()

initCookieConsent()

const isHome = document.body.classList.contains('home')
const isSingleProduct = document.body.classList.contains('single-product')
const isSingleArticle = document.body.classList.contains(
  'post-template-default',
)
const isSingleReference = document.body.classList.contains('single-reference')
const isSingleCampaign = document.body.classList.contains('single-campaign')
const isContact = document.body.classList.contains(
  'page-template-template-contact',
)
const isReferences = document.body.classList.contains(
  'post-type-archive-reference',
)
const isProducts = document.body.classList.contains('post-type-archive-product')
const isAbout = document.body.classList.contains('page-template-template-about')
const isServices = document.body.classList.contains(
  'page-template-template-services',
)
const isSingleBusiness = document.body.classList.contains('single-business')
const isSingleProductFamily = document.body.classList.contains(
  'single-product_family',
)
const isSingleBrand = document.body.classList.contains('single-brand')
const isStoresPage = document.body.classList.contains(
  'page-template-template-stores',
)
const isTabbedPage = document.body.classList.contains(
  'page-template-template-tabs',
)
const isStoresArchive = document.body.classList.contains(
  'post-type-archive-store',
)
// moveMenu()
const isSearchPage = document.body.classList.contains('search')
const hasScrollButton = document.querySelector('.c-scroll')
const hasVideo = document.querySelector('.u-body-copy iframe')
const isJobPage = document.body.classList.contains('single-job')
const isResellersPage = document.body.classList.contains(
  'page-template-template-resellers',
)

// Globals
heroDot([isContact])

const efficientScroll = () => {
  applyShadowToNav()
}
window.addEventListener('scroll', throttle(efficientScroll, 100))
openMenu()
openStickyCTA()
// End Globals

if (isFacetsTemplate) {
  sortProducts()
  triggerFacetChildren()
  setDivHeights()
  facetLoader()

  window.addEventListener('resize', function resize() {
    setDivHeights()
  })
}

if (isJobPage) {
  openApplyModal()
}

if (!isSearchPage) {
  slideInOutSearch()
}

if (hasScrollButton) {
  scrollButton(hasScrollButton)
}

if (isHome) {
  initHomeReferencesSlider()
}

if (isServices) {
  initHomeReferencesSlider()
}

if (isJobPage) {
  moveJobMenu()
}

if (isSingleBusiness) {
  handleClickOnCTA()
  const scrollTriggers = [...document.querySelectorAll('.js-scroll-to')]
  scrollTriggers.forEach(trigger => {
    trigger.addEventListener('click', scrollToEventHandler)
  })
  openServiceModal()
}

if (isSingleCampaign) {
  openCampaignModal()
}

if (isProducts) {
  // Init react
  // init()
}

if (isSingleProduct) {
  initProductSlider()
  show3DViewButton()
  initHomeReferencesSlider()
  initRelProductSlider()
  initRelProductSliderSm()
  initRelReferencesSlider()
  handleSpecsTabs()
  handleSpecsTabs2()
  moveMenu()
  scrollToFinishSection()
}

if (isTabbedPage) {
  // handleSpecsTabs()
  // handleSpecsTabs2()

  const allTabContainers = document.querySelectorAll('[data-tabs]')

  allTabContainers.forEach(el => {
    const tab = new Tabs(el)
    tab.init()
  })

  if (window.location.hash) {
    document.querySelector(`a[href="${window.location.hash}"]`).click()
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
  }
}

if (isReferences) {
  filterReferences()

  if (window.location.hash) {
    const activeFilter = document.querySelector(
      `[data-category="${window.location.hash}"]`,
    )

    activeFilter.click()

    const allInputs = document.querySelectorAll('.c-filter__btn')

    allInputs.forEach(inputElem => {
      inputElem.checked = false
    })

    const activeInput = document
      .querySelector(`[data-category="${window.location.hash}"]`)
      .querySelector('.c-filter__btn')

    activeInput.checked = true
  }
}

function wrapVideo() {
  const videos = document.querySelectorAll('.u-body-copy iframe')

  videos.forEach(video => {
    const wrapper = document.createElement('div')
    wrapper.setAttribute('class', 'c-body-video-wrap')
    // insert wrapper before el in the DOM tree
    video.parentNode.insertBefore(wrapper, video)
    // move el into wrapper
    wrapper.appendChild(video)
  })
}

if (hasVideo) {
  wrapVideo()
}

if (isSingleReference) {
  initSingleReferenceSlider()
}

if (isSingleArticle) {
  initAboutArticlesSlider()
}

if (isAbout) {
  const scrollEventHandler = scrollToEventHandler
  const scrollTos = [...document.querySelectorAll('.js-scroll-to')]
  scrollTos.forEach(element => {
    element.addEventListener('click', scrollEventHandler, true)
  })
  const mapLoaded = document.getElementById('map')
  if (mapLoaded) {
    initProjectsMap()
  }
  initAboutArticlesSlider()
}

if (isSingleProductFamily || isSingleBrand) {
  initHomeReferencesSlider()

  initRelProductSlider()
}

if (isContact) {
  filterPeople()
}

if (isStoresPage || isStoresArchive) {
  window.onload = initStoresMap
}

if (isSearchPage) {
  setNoResultsHeight()
}

if (isResellersPage) {
  handleSpecsTabs()
}

// Export handleLabels to expose through WebPack output variable EntryPoint.
// Use in inline scripts as an EntryPoint method, such as:
// EntryPoint.handleLabels()

export { handleLabels, handlePasswordLabels, hideOnConfirmation }

openChangePasswordModal()
